export default __webpack_public_path__ + "static/media/Component 74 – 1.4a7ce69d.svg";